
import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface ErrorDisplayProps {
  error: Error;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
  // Parse the error stack to display readable information
  const errorStack = error.stack?.split('\n').slice(0, 5).join('\n') || 'No stack trace available';
  
  return (
    <div className="rounded-md bg-destructive/10 border border-destructive/20 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertTriangle className="h-5 w-5 text-destructive" aria-hidden="true" />
        </div>
        <div className="ml-3 space-y-2">
          <h3 className="text-sm font-medium text-destructive">Error details</h3>
          <div className="text-sm text-destructive/90 break-all">
            <p className="font-semibold">{error.name}: {error.message}</p>
            <pre className="mt-2 text-xs overflow-x-auto p-2 bg-destructive/5 rounded border border-destructive/10">
              {errorStack}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;
